import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Button,
  Label,
  Row,
  Col,
  CustomInput,
} from 'reactstrap'
import shortid from 'shortid'
import DatePicker from 'react-datepicker'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import styled from 'styled-components'
import * as CONSTANTS from './constants'

class CreateStandardCostPrice extends React.Component {
  render() {
    const { open, toggle, handleInput } = this.props
    const employee_level = get(this.props, 'employee_level')
    const wmd = get(this.props, 'wmd')
    const sga_price = get(this.props, 'sga_price')
    const sga_support_price = get(this.props, 'sga_support_price')
    const cost = get(this.props, 'cost')
    const price = get(this.props, 'price')
    const start_date = get(this.props, 'start_date')
    const end_date = get(this.props, 'end_date')
    const createStandardCostPrice = get(this.props, 'createStandardCostPrice')
    const handleStartDate = get(this.props, 'handleStartDate')
    const handleEndDate = get(this.props, 'handleEndDate')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader
          toggle={ () => toggle() }
        >
          <HeadLabel>Standard Cost & Price Information</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Container>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>Level</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <CustomInputField
                      type='select'
                      name='employee_level'
                      value={ employee_level }
                      onChange={ (e) => handleInput(e) }
                    >
                      { CONSTANTS.levels.map((g) =>
                        <option key={ shortid() } value={ g.value }>{ g.value }</option>
                      ) }
                    </CustomInputField>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel >Start Date</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <CustomDatePicker
                        autoComplete='off'
                        onChange={ (e) => handleStartDate(e) }
                        name="start_date"
                        placeholderText='DD/MM/YYYY'
                        selected={ start_date }
                        dateFormat="DD/MM/YYYY"
                        showYearDropdown
                        showMonthDropdown
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>End Date</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <CustomDatePicker
                        autoComplete='off'
                        onChange={ (e) => handleEndDate(e) }
                        name="end_date"
                        placeholderText='DD/MM/YYYY'
                        selected={ end_date }
                        dateFormat="DD/MM/YYYY"
                        showYearDropdown
                        showMonthDropdown
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel >Cost/MD</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <NumberField
                        name="cost"
                        value={ cost }
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onChange={ (e) => {
                          e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleInput(e)
                        } }
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>Price/MD</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <NumberField
                        name="price"
                        value={ price }
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onChange={ (e) => {
                          e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleInput(e)
                        } }
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>Weighted MD</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <NumberField
                        name="wmd"
                        value={ wmd }
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onChange={ (e) => {
                          e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleInput(e)
                        } }
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>SGA (WMD)</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <NumberField
                        name="sga_price"
                        value={ sga_price }
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onChange={ (e) => {
                          e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleInput(e)
                        } }
                      />
                    </ColDate>
                  </Col>
                </Row>
                <Row style={ { marginTop: 10 } }>
                  <Col sm={ 3 }>
                    <TextLabel>SGA Support (MD)</TextLabel>
                  </Col>
                  <Col sm={ 9 }>
                    <ColDate>
                      <NumberField
                        name="sga_support_price"
                        value={ sga_support_price }
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        onChange={ (e) => {
                          e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                          handleInput(e)
                        } }
                      />
                    </ColDate>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <CreateButton
            // disabled={ user === '' }
            onClick={ () => createStandardCostPrice() }
          >Create</CreateButton>
        </ModalFooter>
      </Modal>
    )
  }
}

CreateStandardCostPrice.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  handleInput: PropTypes.func,
}
CreateStandardCostPrice.defaultProps = {
  open: false,
  toggle: () => {},
  handleInput: () => {},
}

export default CreateStandardCostPrice

const HeadLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 16px ;
  color: #AD2624;
`
const TextLabel = styled(Label)`
  font-family: Gotham-Bold;
  font-size: 12px ;
  color: #333333;
  margin-bottom: 0px ;
`
const NumberField = styled(NumberFormat)`
  font-family: Gotham;
  text-align: right;
  width : 100%;
  heigth: 100%;
  font-size: 14px;
  padding-right: 2%;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
    if (props.disabled) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const ColDate = styled(Col)`
  width : 100%;
  padding-left: 0px;
`
const CustomDatePicker = styled(DatePicker)`
  font-family: Gotham;
  width : 150px;
  height : 30px;
  font-size: 12px;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
@media (max-width: 575.98px) {
    width: 100%;
  }
`
const CreateButton = styled(Button)`
  font-family: Gotham;
  font-size: 12px;
  background-color: #AD2624;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
    }
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/standard-cost-price/create-standard-cost-price.js